import { Nullable } from "@core/domain/types/nullable.type";
import { CostSubtypeEnumDto } from "@entity/data/dto/cost/cost-type.dto";
import { CostSubtypeEnum } from "@entity/domain/models/cost/cost-type.model";
import { injectable } from "inversify";

@injectable()
export class CostSubtypeEnumMapper {
    map(costSubtypeEnumDto: Nullable<CostSubtypeEnumDto>): Nullable<CostSubtypeEnum> {
        if (!costSubtypeEnumDto) return null;

        switch (costSubtypeEnumDto) {
            case CostSubtypeEnumDto.DISPLACEMENT:
                return CostSubtypeEnum.DISPLACEMENT;
            case CostSubtypeEnumDto.ACCOMMODATION_MEALS:
                return CostSubtypeEnum.ACCOMMODATION_MEALS;
            case CostSubtypeEnumDto.THIRD_PARTY_ACCOUNT:
                return CostSubtypeEnum.THIRD_PARTY_ACCOUNT;
            case CostSubtypeEnumDto.THIRD_PARTY_SERVICES:
                return CostSubtypeEnum.THIRD_PARTY_SERVICES;
            case CostSubtypeEnumDto.RENT:
                return CostSubtypeEnum.RENT;
            case CostSubtypeEnumDto.UTILITIES:
                return CostSubtypeEnum.UTILITIES;
            case CostSubtypeEnumDto.UTILITIES_CONSTRUCTION_AND_EQUIPMENT:
                return CostSubtypeEnum.UTILITIES_CONSTRUCTION_AND_EQUIPMENT;
            case CostSubtypeEnumDto.INSURANCE:
                return CostSubtypeEnum.INSURANCE;
            case CostSubtypeEnumDto.CONSUMABLES:
                return CostSubtypeEnum.CONSUMABLES;
            case CostSubtypeEnumDto.MATERIALS_FOR_ACTIVITIES:
                return CostSubtypeEnum.MATERIALS_FOR_ACTIVITIES;
            case CostSubtypeEnumDto.TRANSPORT_OF_GOODS_AND_INMOVILITIES:
                return CostSubtypeEnum.TRANSPORT_OF_GOODS_AND_INMOVILITIES;
            case CostSubtypeEnumDto.OCCASIONAL_COLLABORATIONS:
                return CostSubtypeEnum.OCCASIONAL_COLLABORATIONS;
            case CostSubtypeEnumDto.CONFERENCES_LECTURES:
                return CostSubtypeEnum.CONFERENCES_LECTURES;
            case CostSubtypeEnumDto.WORK_OTHER_COMPANIES:
                return CostSubtypeEnum.WORK_OTHER_COMPANIES;
            case CostSubtypeEnumDto.VOLUNTEERING:
                return CostSubtypeEnum.VOLUNTEERING;
            case CostSubtypeEnumDto.LIABILITY_INSURANCE:
                return CostSubtypeEnum.LIABILITY_INSURANCE;
            case CostSubtypeEnumDto.EXPENSES_INCURRED_BENEFICIARIES:
                return CostSubtypeEnum.EXPENSES_INCURRED_BENEFICIARIES;
            case CostSubtypeEnumDto.SOFTWARE_LICENSES:
                return CostSubtypeEnum.SOFTWARE_LICENSES;
            case CostSubtypeEnumDto.OTHERS_MINOR_EXPENSES:
                return CostSubtypeEnum.OTHERS_MINOR_EXPENSES;
            case CostSubtypeEnumDto.FURNITURE:
                return CostSubtypeEnum.FURNITURE;
            case CostSubtypeEnumDto.COMPUTER_EQUIPMENT:
                return CostSubtypeEnum.COMPUTER_EQUIPMENT;
            case CostSubtypeEnumDto.REAL_ESTATE:
                return CostSubtypeEnum.REAL_ESTATE;
            case CostSubtypeEnumDto.OTHERS_INVESTMENT_EXPENSES:
                return CostSubtypeEnum.OTHERS_INVESTMENT_EXPENSES;
            case CostSubtypeEnumDto.CONSULTING_SERVICES:
                return CostSubtypeEnum.CONSULTING_SERVICES;
            case CostSubtypeEnumDto.AUDITING:
                return CostSubtypeEnum.AUDITING;
            case CostSubtypeEnumDto.LABOR_MANAGEMENT_LICENSES:
                return CostSubtypeEnum.LABOR_MANAGEMENT_LICENSES;
            case CostSubtypeEnumDto.QUALITY:
                return CostSubtypeEnum.QUALITY;
            case CostSubtypeEnumDto.PERSONNEL:
                return CostSubtypeEnum.PERSONNEL;
            default:
                return null;
        }
    }

    mapToDto(costSubtypeEnum: Nullable<CostSubtypeEnum>): Nullable<CostSubtypeEnumDto> {
        if (!costSubtypeEnum) return null;

        // eslint-disable-next-line default-case
        switch (costSubtypeEnum) {
            case CostSubtypeEnum.DISPLACEMENT:
                return CostSubtypeEnumDto.DISPLACEMENT;
            case CostSubtypeEnum.ACCOMMODATION_MEALS:
                return CostSubtypeEnumDto.ACCOMMODATION_MEALS;
            case CostSubtypeEnum.THIRD_PARTY_ACCOUNT:
                return CostSubtypeEnumDto.THIRD_PARTY_ACCOUNT;
            case CostSubtypeEnum.THIRD_PARTY_SERVICES:
                return CostSubtypeEnumDto.THIRD_PARTY_SERVICES;
            case CostSubtypeEnum.RENT:
                return CostSubtypeEnumDto.RENT;
            case CostSubtypeEnum.UTILITIES:
                return CostSubtypeEnumDto.UTILITIES;
            case CostSubtypeEnum.UTILITIES_CONSTRUCTION_AND_EQUIPMENT:
                return CostSubtypeEnumDto.UTILITIES_CONSTRUCTION_AND_EQUIPMENT;
            case CostSubtypeEnum.INSURANCE:
                return CostSubtypeEnumDto.INSURANCE;
            case CostSubtypeEnum.CONSUMABLES:
                return CostSubtypeEnumDto.CONSUMABLES;
            case CostSubtypeEnum.MATERIALS_FOR_ACTIVITIES:
                return CostSubtypeEnumDto.MATERIALS_FOR_ACTIVITIES;
            case CostSubtypeEnum.TRANSPORT_OF_GOODS_AND_INMOVILITIES:
                return CostSubtypeEnumDto.TRANSPORT_OF_GOODS_AND_INMOVILITIES;
            case CostSubtypeEnum.OCCASIONAL_COLLABORATIONS:
                return CostSubtypeEnumDto.OCCASIONAL_COLLABORATIONS;
            case CostSubtypeEnum.CONFERENCES_LECTURES:
                return CostSubtypeEnumDto.CONFERENCES_LECTURES;
            case CostSubtypeEnum.WORK_OTHER_COMPANIES:
                return CostSubtypeEnumDto.WORK_OTHER_COMPANIES;
            case CostSubtypeEnum.VOLUNTEERING:
                return CostSubtypeEnumDto.VOLUNTEERING;
            case CostSubtypeEnum.LIABILITY_INSURANCE:
                return CostSubtypeEnumDto.LIABILITY_INSURANCE;
            case CostSubtypeEnum.EXPENSES_INCURRED_BENEFICIARIES:
                return CostSubtypeEnumDto.EXPENSES_INCURRED_BENEFICIARIES;
            case CostSubtypeEnum.SOFTWARE_LICENSES:
                return CostSubtypeEnumDto.SOFTWARE_LICENSES;
            case CostSubtypeEnum.OTHERS_MINOR_EXPENSES:
                return CostSubtypeEnumDto.OTHERS_MINOR_EXPENSES;
            case CostSubtypeEnum.FURNITURE:
                return CostSubtypeEnumDto.FURNITURE;
            case CostSubtypeEnum.COMPUTER_EQUIPMENT:
                return CostSubtypeEnumDto.COMPUTER_EQUIPMENT;
            case CostSubtypeEnum.REAL_ESTATE:
                return CostSubtypeEnumDto.REAL_ESTATE;
            case CostSubtypeEnum.OTHERS_INVESTMENT_EXPENSES:
                return CostSubtypeEnumDto.OTHERS_INVESTMENT_EXPENSES;
            case CostSubtypeEnum.CONSULTING_SERVICES:
                return CostSubtypeEnumDto.CONSULTING_SERVICES;
            case CostSubtypeEnum.AUDITING:
                return CostSubtypeEnumDto.AUDITING;
            case CostSubtypeEnum.LABOR_MANAGEMENT_LICENSES:
                return CostSubtypeEnumDto.LABOR_MANAGEMENT_LICENSES;
            case CostSubtypeEnum.QUALITY:
                return CostSubtypeEnumDto.QUALITY;
            case CostSubtypeEnum.PERSONNEL:
                return CostSubtypeEnumDto.PERSONNEL;
            default:
                return null;
        }
    }
}